export default __webpack_public_path__ + "static/media/movingunit.a248e0a0.jpg";